/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React from 'react';

import { ProfileItemContent, ProfileItemImage, ProfileItemText } from './styled';

import { withFocusable } from '@noriginmedia/react-spatial-navigation';

export default withFocusable({})(function ProfileItem({
  onPress,
  item,
  focused,
}: {
  onPress?: () => void;
  item: { name?: string; image?: { uri: string } };
  focused?: boolean;
}) {
  return (
    <>
      <ProfileItemContent onPress={onPress}>
        <ProfileItemImage source={item?.image} focused={focused} />
        <ProfileItemText focused={focused}>{item?.name}</ProfileItemText>
      </ProfileItemContent>
    </>
  );
});
